import React, { Component } from 'react';
import * as api from '../api/api';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';

import StatusMessage from '../util/StatusMessage'

class ResumeTab extends Component{

constructor(props){
super(props)
this.state = {
  errorMsg: '',
  uploadDisabled: true,
  uploadStatusMessage: '',
  data:{
  resume: '',
  resume_url: ''
  },
  fileSize:{    
    fileMaxSize:10
    
  },
  formErrors:{
    fileError:''
  }
};
  this.handleSubmit = this.handleSubmit.bind(this);
  this.onInputChange = this.onInputChange.bind(this)

}

componentDidMount()
{
  var curr = this;
    let data = Object.assign({}, this.state.data);
    api.getResume(this.props.user.accessToken).then(function(result){
      if (result.id) {
      data.id = result.user_id? result.user_id: '';
      data.resume = result.resume? result.resume : '';
      data.resume_url = result.resume_url? result.resume_url: '';
      }
      curr.setState({data: data})
      })
}

handleSubmit(e) {
    e.preventDefault()
    const formData = new FormData(e.target);
    this.setState({uploadDisabled:true, uploadStatusMessage:'Upload in Progress. Please wait'})
    api.saveResume(this.props.user.accessToken,formData)
    .then((result) => {
       
       const data = Object.assign({}, this.state.data);
       
       if(result.errors){
        
        this.setState({ errorMsg: result.errors, uploadDisabled:false, uploadStatusMessage:'' })

       }
       else{
        data.resume_url = result.resume_url;
        this.setState({data: data, uploadDisabled:true, uploadStatusMessage:'Resume Uploaded. Please click on View Resume to View the uploaded resume'});
      }
       
    })
    .catch((err) => {
    // console.log(`error:${err.stack}`)
      this.setState({ errorMsg: 'Error in Upload. Please contact Admin', uploadDisabled:false, uploadStatusMessage:'' })
    })
  }

onInputChange = evt =>{

  if(evt.target.files[0] === undefined)
    return
  
  let fileSize = evt.target.files[0].size/1024/1024;
  let file_name = evt.target.files[0].name;
  let file_type = evt.target.files[0].type;


  let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();

  if(fileSize < this.state.fileSize.fileMaxSize){
    if (extension == "pdf" || extension == "doc" || extension == "docx"){
       const formErrors = Object.assign({}, this.state.formErrors);
      formErrors.fileError =''
      this.setState({uploadDisabled: false, formErrors: formErrors, uploadStatusMessage: ''})
    }
    else{
      const formErrors = Object.assign({}, this.state.formErrors);
      formErrors.fileError ='Invalid file format. Please check'
      this.setState({formErrors: formErrors, uploadDisabled:true, uploadStatusMessage: ''})
    }

  }
  else{
    const formErrors = Object.assign({}, this.state.formErrors);
    formErrors.fileError ='File Size exceeds maximum limit of ' + this.state.fileSize.fileMaxSize + ' MB'
    this.setState({formErrors: formErrors, uploadDisabled:true, uploadStatusMessage: ''})
  }

    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };


render(){

  let resumeUrl
  if(!this.state.data.resume_url.length == 0){
    resumeUrl = (<a href ={this.state.data.resume_url} target="_blank">View Resume</a>)
  }

  let uploadButtonComponent
  if(!this.state.uploadDisabled){
    uploadButtonComponent = <Button raised>Upload</Button>
  }
  else{
    uploadButtonComponent = <Button disabled raised>Upload</Button>
  } 
  
  return (

      <Grid>
        <GridCell span="12">
          <form  onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
              
              <GridCell span="12">
                <Typography use="subtitle">Upload Resume</Typography>
              </GridCell>
              <ListDivider/>

              <Grid className="opportunity-list-item">
                <GridCell span="5">
                  <input type="file" name="resume"  onChange={this.onInputChange} />
                </GridCell>

                <GridCell span="2">
                  {uploadButtonComponent}
                </GridCell>
                <GridCell span="5">
                  
                </GridCell>

                <GridCell span="5">
                  {resumeUrl}
                </GridCell>

                <GridCell span="7">
                  
                </GridCell>
                 <GridCell span="12">
                  <Typography use="body2"><i>{this.state.uploadStatusMessage}</i></Typography>                  
                  <StatusMessage error_msg = {this.state.errorMsg}/>
                  <StatusMessage error_msg = {this.state.formErrors.fileError}/>
                </GridCell>
              </Grid>
              <ListDivider/>

              <GridCell span="12">
                <Typography use="body2"><b>Note:</b> <i>Choose a file and click on Upload to Upload the resume. To view uploaded resume, click on View Resume link</i></Typography>
              </GridCell>
              
            </Card>
          </form>
        </GridCell>
      </Grid>



    )
    


}

  

}

export default ResumeTab;


// WEBPACK FOOTER //
// ./src/views/ResumeTab.jsx